module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/master/religion/religion-grid/religion-grid.component.css
// module id = ./src/app/master/religion/religion-grid/religion-grid.component.css
// module chunks = main